import { kanziSections } from "../../../../content/kanziSections";
import Eyebrow from "../../Eyebrow";
import Reveal from "../../Reveal";

const Approach = () => {
  const steps = kanziSections.approach.steps;

  return (
    <section className="section-block section-block--framed kanzi-approach-section">
      <div className="kanzi-approach__split">
        <div className="kanzi-approach__left">
          <div className="kanzi-approach__left-inner">
            <Eyebrow>{kanziSections.approach.eyebrow}</Eyebrow>
            <h2 className="kanzi-approach__title">{kanziSections.approach.title}</h2>
            <p className="kanzi-approach__desc">{kanziSections.approach.description}</p>
            <p className="kanzi-approach__footer">{kanziSections.approach.footer}</p>
          </div>
        </div>

        <div className="kanzi-approach__right">
          {steps.map((step, index) => (
            <div key={step.number} className="kanzi-timeline-zone">
              <Reveal variant="fade-up">
                <div className="kanzi-timeline-step">
                  <div className="kanzi-timeline-step__track">
                    <div className="kanzi-timeline-step__circle">
                      <span>{step.number}</span>
                    </div>
                    {index < steps.length - 1 && (
                      <div className="kanzi-timeline-step__connector" />
                    )}
                  </div>
                  <div className="kanzi-timeline-step__content">
                    <h3 className="kanzi-timeline-step__title">{step.title}</h3>
                    <p className="kanzi-timeline-step__desc">{step.description}</p>
                  </div>
                </div>
              </Reveal>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Approach;
